"use client";
import React, { useState } from "react";
import { Image } from "@heroui/image";
import { cn } from "@heroui/theme";
import { motion } from "framer-motion";

interface Props {
    className?: string;
    data: {
        avatar: string;
        first_name: string;
        last_name: string;
        position: string;
    };
}

const TeamMembers = ({ className, data }: Props) => {
    const [scaleAnime, setScaleAnime] = useState(false);

    return (
        <motion.div
            key={data.avatar}
            className={cn(
                "relative  rounded-xl min-w-44 w-44 h-[35vh]  overflow-hidden",
                className,
            )}
            onClick={() => setScaleAnime((prev) => !prev)}
            onHoverEnd={() => setScaleAnime(false)}
            onHoverStart={() => setScaleAnime(true)}
        >
            <motion.div className="absolute inset-0">
                <Image
                    alt="Preview"
                    className={cn(
                        "object-cover object-top   min-w-44 w-44 h-[35vh] rounded-xl ",
                        className,
                        scaleAnime && "scale-110",
                    )}
                    src={data.avatar}
                />
            </motion.div>
            <div className="absolute inset-0 flex flex-col justify-end p-3 text-white z-10 bg-gradient-to-t from-black/80 via-transparent to-transparent rounded-xl">
                <div
                    className={`transition-all duration-300 ease-in-out transform ${scaleAnime ? " -translate-y-4" : " translate-y-0"}`}
                >
                    <div className="text-2xl">{data.first_name}</div>
                    <div className="text-2xl">{data.last_name}</div>
                    <div className="text-xs">{data.position}</div>
                </div>
            </div>
        </motion.div>
    );
};

export default TeamMembers;